export default "__VITE_ASSET__CeRMeMNF__"